module.exports = __webpack_public_path__ + "img/big-data-1.930a3011.png";